import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const scheduleCheckupService = {
  getFilteredScheduleCheckups: ({ pageNumber = 1, tab, ...data }: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.getFilteredScheduleCheckups(),
      config: {
        params: { pageNumber, tab },
      },
      data: {
        companyId: data.companyId,
        name: data.search || '',
        stores: data.stores,
      },
    });
  },

  getAllScheduleCheckup: ({ page, ...params }: any) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllScheduleCheckup(),
      config: {
        params: {
          pageNumber: page || 1,
          ...params,
        },
      },
    });
  },

  downloadScheduleCheckupExcel: ({ tab, ...data }: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.downloadScheduleCheckupExcel(),
      config: { params: { tab }, responseType: 'blob' },
      data: {
        companyId: data.companyId,
        name: data.search || '',
        stores: data.stores,
      },
    });
  },

  updateScheduleCheckupStatus: (data: any) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.updateScheduleCheckupStatus(),
      data,
    });
  },
};

export default scheduleCheckupService;
